module.exports = __webpack_public_path__ + "img/logo-om.e5f86de2.svg";